<script lang="ts">
	import { type FontProps, DefaultRobotoFontProps, getFontPropsVarString } from '$types/fontProps'
	import { type Breadcrumb, breadcrumbs } from './Breadcrumbs/breadcrumbs.svelte'

	type BreadcrumbProps = {
		clickable?: boolean
		fontProps?: FontProps
		separator?: string
		context?: string
	}

	let {
		clickable = true,
		fontProps = DefaultRobotoFontProps('21px', '14px'),
		separator = '>',
		context = 'default'
	}: BreadcrumbProps = $props()

	let fontPropsVarString: string = $derived(getFontPropsVarString(fontProps))

	function navigate(breadcrumb: Breadcrumb, index: number) {
		if (clickable && breadcrumb.callback) {
			breadcrumb.callback(breadcrumb.data, index)
		}
		// TODO think about that, how we can allow to navigate and make error handling when unsaved changes etc.
	}

	const currentBreadcrumbs = $derived(breadcrumbs.get(context))
</script>

<div class="breadcrumbs" style={fontPropsVarString} class:clickable>
	{#each currentBreadcrumbs as breadcrumb, i (i)}
		<button type="button" onclick={() => navigate(breadcrumb, i)} disabled={!clickable}
			>{breadcrumb.title}</button
		>

		{#if i < currentBreadcrumbs.length - 1}
			<!-- for all except the last element -->
			<span class="breadcrumbs__separator">{separator}</span>
			<!--this > is on purpose ! -->
		{/if}
	{/each}
</div>

<!-- TODO breadcrumbs that are navigable or not depending on boolean -->
<!-- TODO this component could also include and manage a stack with the elements that are needed for every breadcrumb -->
<!-- TODO this stack could include the UI components and the according parameters and objects that are used on this component -->

<style lang="scss">
	@import '$styles/global';

	div.breadcrumbs {
		--color: #{$grey-800};

		@include flex-row(0.25rem, $justify: flex-start, $alignment: center);
		@include roboto-font(var(--line-height), var(--font-weight), var(--font-size), var(--color));

		flex-wrap: wrap;
		width: 100%;

		& > button {
			color: var(--color);
			text-decoration: none;
			cursor: pointer;
			border: none;
			background: none;
			padding: 0;
			//margin: 0;
		}

		& > button:last-of-type {
			color: $primaryGreen;
		}
	}
</style>
